import {
  Component,
  Injector,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from "@angular/core";
import { TransactionDto } from "../../../../dto/transactionDto";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";
import { TransactionsService } from "@services/entity/transactions.service";
import { AuthenticationService } from "@services/authentication/authentication.service";
import { RemoteStartStopDialogContentComponent } from "@components/dialog/remote-start-stop-dialog-content/remote-start-stop-dialog-content.component";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "running-transaction-popup",
  templateUrl: "./running-transaction-popup.component.html",
  styleUrls: ["./running-transaction-popup.component.scss"],
})
export class RunningTransactionPopupComponent implements OnInit {
  @Input() transaction: TransactionDto;
  @Input() isOpen: boolean = false;
  @Output() isClosing: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isOperator: boolean;
  public isCustomer: boolean;
  public isUser: boolean;
  public isRequestingSupport: boolean = false;
  public customerId: string;

  constructor(
    private authenticationService: AuthenticationService,
    public datePipe: DatePipe,
    private dialog: NgbModal,
    public injector: Injector,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.customerId = this.route.parent.snapshot.params.key;

    if (this.authenticationService.userHasRole("Operator"))
      this.isOperator = true;
    if (this.authenticationService.userHasRole("Customer"))
      this.isCustomer = true;
    if (this.authenticationService.userHasRole("User")) this.isUser = true;
  }

  close() {
    this.isClosing.emit(true);
  }

  openRemoteStopDialog(transaction: TransactionDto) {
    const dialogRef = this.dialog.open(RemoteStartStopDialogContentComponent, {
      centered: true,
      backdrop: "static",
    });
    dialogRef.componentInstance.transaction = transaction;
  }

  getChargingPointPosition(transaction: TransactionDto) {
    if (!transaction) return "";
    if (!transaction.chargingStationNumberOfChargingPoints) return "";

    if (transaction.chargingStationNumberOfChargingPoints > 1) {
      return `(Ladepunkt ${transaction.connectorId})`;
    }

    return "";
  }

  matches(entity: TransactionDto, term: string) {
    return TransactionsService.matches(entity, term);
  }

  openSupportPopup() {
    this.isRequestingSupport = true;
  }

  closeSupportPopup() {
    this.isRequestingSupport = false;
  }
}
